import React from 'react';
import { useSelector } from 'react-redux';

import MaxWidth from '@/components/common/layout/MaxWidth';
import { listingPageAnchors } from '@/constants/anchors';
import {
  getBundledListings,
  isLoadingBundledListingsData,
} from '@/redux/selectors/bundledListings';
import { getFromAndTo } from '@/redux/selectors/queryParams';

import { BundledListings } from './BundledListings';
import { NoResultMessage } from './NoResultMessage';
import { SearchFilters } from './SearchFilters';
import { getNumberOfNights } from './util';

export enum EBundledListingsTileOrientation {
  Horizontal = 'horizontal',
  Vertical = 'vertical',
}

interface IProps {
  scrollToSearchFilter: () => void;
  searchFilterRef: React.RefObject<HTMLDivElement>;
}

export const BookAnRVSuite: React.FC<IProps> = ({ scrollToSearchFilter, searchFilterRef }) => {
  const bundledListingsData = useSelector(getBundledListings);
  const isLoadingData = useSelector(isLoadingBundledListingsData);
  const dates = useSelector(getFromAndTo);
  const nights = getNumberOfNights(dates);

  return (
    <section className="py-8 md:py-12" id={listingPageAnchors.VACATION_PACKAGES_BOOK_AN_RV_SUITE}>
      <MaxWidth className="mx-auto">
        <SearchFilters ref={searchFilterRef} />

        {!bundledListingsData?.length && !isLoadingData ? (
          <NoResultMessage nights={nights} />
        ) : (
          <BundledListings
            listingsData={bundledListingsData}
            scrollToSearchFilter={scrollToSearchFilter}
            orientation={EBundledListingsTileOrientation.Vertical}
            isLoadingData={isLoadingData}
          />
        )}
      </MaxWidth>
    </section>
  );
};

BookAnRVSuite.displayName = 'BookAnRVSuite';
